import React from "react";
import "../InvestmentRoundScreen/styles.css";

const DiscussionScreen = () => {
    return (
        <div className="gameTimeManagementContainer">
            <span
                className="gameTimeManagementText"
                style={{ marginRight: "32px" }}
            >
                <span className="gameComponentsTitle">
                    Discussion Screen <span className="gameComponentsTitleTask">(Task 1)</span>
                </span>
                🅐 Shows the discussion phase and the remaining time.
                <br /><br />
                🅑 Displays important discussion rules and reminders.
                <br /><br />
                🅒 Shows the discussion main topic.
                <br /><br />
                🅓 Displays a discussion angle related to the topic. This may change during the discussion, so pay attention to it and discuss from the perspective shown.
                <br /><br />
                🅔 Text box for typing your message to your partner.
                <br /><br />
                🅕 Sends your message to the chat.
                <br />
            </span>
            <img
                src={require("../../../../assets/components_2.png")}
                alt="Discussion Screen"
                style={{ height: "60vh", alignSelf: 'flex-end' }}
            />
        </div>
    );
};

export default React.memo(DiscussionScreen);
